import { Customer } from '@e-origin/shared';

import { FetchCustomerProps, useCustomers } from './useCustomers';

export const useCustomersNamesAndIds = (values?: FetchCustomerProps) => {
  const {
    data: { list },
  } = useCustomers(values);

  return (
    list.map((customer: Customer) => ({
      label: customer.name || '',
      value: customer._id || '',
    })) || []
  );
};
